export const getAbsoluteUrlToSite = function getAbsoluteUrlToSite(path) {
    return new URL(path, window.location.origin).href;
};
//# sourceMappingURL=getAbsoluteUrlToSite.js.map